<template>
    <div>
        <div class="page-title">Add  Event</div>
        <div class="page-box">
            <eventStatusManageFrom ref="ruleForm" :ruleForm="ruleForm"></eventStatusManageFrom>
            <div class="page-button">
             <el-button type="warning" @click="onSubmit">Submit</el-button>
              <el-button  @click="onBack">Cancel</el-button>
            </div>
        </div>
         
    </div>
</template>

<script>
    import {addEventStatuses} from '@/api/admin/event-statuses'
    import eventStatusManageFrom from './components/eventStatusManageFrom.vue'
    export default {
        components:{eventStatusManageFrom},
        data() {
            return {
                ruleForm: {
                    title: "", 
                    type: null, 
                    registrationNo: null, 
                    startDate: "", 
                    endDate: "", 
                    isExpired: false, 
                    applicationNode: "",
                    level1:'',
                    level2:'',
                    level3:''
                },
            }
        },
        methods:{
            onSubmit(){
                this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.addEventStatuses()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
                
            },
            addEventStatuses(){
                addEventStatuses(this.ruleForm).then(()=>{
                     this.$router.push({path:'/admin/eventStatusManage'})
                })
            }
        }
        
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
    padding: 20px;
}
.page-button{
    text-align: right;
}
</style>